import { useCallback, useMemo } from 'react';
import { createEditor, Descendant } from 'slate';
import { Slate, Editable, withReact, RenderElementProps, RenderLeafProps } from 'slate-react';
import { Leaf, SlateRenderElement, withHtml } from './slate-editor-components';

export interface RichTextContentProps {
  content: Descendant[] | null;
  className?: string;
}

const RichTextContent = ({ content }: any) => {
  const editor = useMemo(() => withHtml(withReact(createEditor())), []);

  const renderElement = useCallback(
    (props: RenderElementProps) => <SlateRenderElement {...props} />,
    []
  );

  const renderLeaf = useCallback((props: RenderLeafProps) => <Leaf {...props} />, []);
  return (
    <Slate editor={editor} initialValue={content}>
      <div className="bg-gray-700 rounded-lg p-4 border border-gray-700">
        <Editable
          renderElement={renderElement}
          renderLeaf={renderLeaf}
          readOnly
          placeholder="Enter some plain text..."
        />
      </div>
    </Slate>
  );
};

export default RichTextContent;
